import { useQuery } from "@tanstack/react-query";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import http_payroll from "AppQuries/utils/http_payroll";

const fetchEmployeeCount = async ({
  companyCode,
  locationCode,
  status,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  if (isAllCompanies) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.AllCompanies_GetCountListReport}?companyCode=${selectedCompanyCode}&locationCode=${locationCode}&status=${status}&UserId=${userId}`,
    );
    return data;
  }
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetEmployeeCountList}?companyCode=${companyCode}&locationCode=${locationCode}&status=${status}`,
  );

  return data;
};

export const useEmployeeCount = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetCountListReport
        : Api_EndPoints.GetEmployeeCountList,
    ],
    queryFn: () => fetchEmployeeCount(input),
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
